import { TypographyMuted, TypographySmall } from '@talentmesh/ui/components/typography';
import React from 'react';

interface StatusInfoProps {
    label: string;
    children?: React.ReactNode;
    textTransform?: 'capitalize' | 'uppercase' | 'lowercase' | 'none';
}

const StatusInfo = ({ label, children, textTransform }: StatusInfoProps) => {
    return (
        <>
            <div className="col-span-3">
                <TypographyMuted>{label}</TypographyMuted>
            </div>
            <div className="col-span-9">
                <TypographySmall className={`whitespace-nowrap ${textTransform ? `text-${textTransform}` : ''}`}>
                    {children}
                </TypographySmall>
            </div>
        </>
    );
};

export default StatusInfo;
